
// AlertsPanel.js (simple, no JSX)
import React from "react";
import { NrqlQuery, TableChart, Spinner, EmptyState } from "nr1";
import PropTypes from "prop-types";


const DEFAULT_QUERY = `SELECT tags.group as 'group', entity.name as 'hostname',conditionName,  openTime, priority, event, incidentLink  FROM NrAiIncident WHERE type like 'Incident'and tags.group IN ('digitalordering', 'sesame','eprod','mystore') AND incidentId NOT IN (SELECT incidentId FROM NrAiIncident WHERE type like 'Incident' AND event = 'close' and tags.group IN ('digitalordering', 'sesame','eprod','mystore') since 30 days ago LIMIT MAX)  since 30 day ago LIMIT MAX`;

export default function AlertsPanel({
  accountId =  accountId,
  query = DEFAULT_QUERY,
  pollInterval = 60000,
}) {
  //return ("HHHHHHHHHh");
    if(accountId == "cross-account"){
       accountId = 4091918;
    }
  return React.createElement(
    "div",
    { className: "alerts-panel" },
    React.createElement(NrqlQuery, {
      accountId,
      query,
      pollInterval,
      children: ({ data, loading, error }) => {
        if (error) {
          return React.createElement(EmptyState, {
            heading: "Query error",
            description: String(error.message || error),
          });
        }
        if (loading || !data) {
          return React.createElement(
            "div",
            { className: "alerts-loading" },
            React.createElement(Spinner, null),
            " Loading..."
          );
        }
        if (!Array.isArray(data) || data.length === 0) {
          return React.createElement("div", null, "No incidents found.");
        }
        return React.createElement(
          "div",
          { className: "alerts-table-container" },
          React.createElement(TableChart, { data, fullWidth: true })
        );
      },
    })
  );
}

AlertsPanel.propTypes = {
  accountId: PropTypes.number.isRequired,
  query: PropTypes.string.isRequired,
  pollInterval: PropTypes.number,
};
